import React, {useEffect, useState} from "react";
import Main from "../components/main";

import Header from "../components/section/header";
import Footer from "../components/section/footer";
import {getCurrentUserQuery} from "../components/logic/user";
import { useQuery } from "@apollo/client";
import Loader from "../components/bootstrap/loader";
import ConveyorBelt from "../components/conveyor-belt";
import {Col, Row} from "react-bootstrap";
import "../style/custom/select-address.scss";
import SignUpControl from "../controls/register/new-sign-up";
// import config from "../config";
import UserCheck from "../components/utils/user-check";


export default function SignUpPage(props) {
  return (
    <Main>
      <UserCheck {...props}>
        <SignUpUser />
      </UserCheck>
    </Main>
  );
}


const SignUpUser = () => {
  return (<Main>
    <Header />
    <div className="vw-outside-pages">
      <div
        className="vw-landing"
      >
        <div className="section-1">
          <Row className="vw-fs">
            <Col xs={12} md={12} lg={3} className="vw-fs-section">
              <div className="sub-section-2">
                <div className="vw-section-panel">
                  <Row>
                    <Col xs={12} className="vw-title">
                      {""}
                    </Col>
                  </Row>
                  <SignUpControl/>
                </div>
              </div>
            </Col>
            
          </Row>
        </div>
        <Footer colour="black" />
      </div>
    </div>
  </Main>);
};

